module.exports = __webpack_public_path__ + "img/monster_book_of_monsters.c40851ac.jpg";